import { useEffect, useMemo } from "react";

export default function useMutationObserver({
  target,
  options = { attributes: true },
  callback,
}) {
  const observer = useMemo(
    () =>
      new MutationObserver((mutationRecord, mutationObserver) => {
        callback?.(mutationRecord, mutationObserver);
      }),
    [callback]
  );

  useEffect(() => {
    const element = target?.current;

    if (observer && element) {
      observer.observe(element, options);
      return () => observer.disconnect();
    }
  }, [target, observer, options]);
}
